/* eslint-disable no-restricted-globals */

export const DefaultLocale = "en";
export const ADMIN = "Admin";
export const USER_PERMISSIONS = {
  category: "userManagement",
  subCategory: "users",
  create: "create",
  update: "update",
};
export const createAndUpdateRole = (checkedPermissions) => {
  const rolePermissionsMap = {};
  // Step 1: Build rolePermissionsMap based on checkedPermissions
  Object?.keys(checkedPermissions)?.forEach((key) => {
    if (checkedPermissions[key]) {
      const [roleId, , , permissionId] = key.split("-");
      if (!rolePermissionsMap[roleId]) {
        rolePermissionsMap[roleId] = [];
      }
      if (permissionId) {
        rolePermissionsMap[roleId].push(permissionId);
      }
    }
  });
  // Step 2: Format roles data
  const formattedRoles = Object?.keys(rolePermissionsMap)?.map((roleId) => ({
    role_id: roleId,
    permissions: rolePermissionsMap[roleId],
  }));

  // Step 3: Separate roles into createRole and updateRole
  const createRole = formattedRoles?.filter((role) => role?.role_id === "newColumn");
  const updateRole = formattedRoles?.filter((role) => role?.role_id !== "newColumn");

  return { createRole, updateRole };
};
export const getAdminRoles = (data) => {
  return data.filter((item) => item.role === ADMIN);
};
const DisableCategory = ["Role"].map((category) => category?.toLowerCase()?.trim());
export const isDisabled = (role, moduleName) => {
  if (
    moduleName?.category &&
    DisableCategory.includes(
      moduleName?.category?.toLowerCase()?.trim() ||
        moduleName?.sub_category?.toLowerCase()?.trim(),
    )
  ) {
    return true;
  } else if (role) {
    return role === ADMIN;
  }
};
export const generateDomain = (site) => {
  if (site?.domain_name && site.site_address) {
    const domainName = site?.domain_name?.replace(".com.", ".com");
    return site?.site_address
      ? `https://${site.site_address}.${domainName}`
      : `https://${domainName}`;
  }
};
